module.exports = __webpack_public_path__ + "img/sintesis.0f01c91b.svg";